export default {
    'diagram3a3-1': {
        'diagram-task': 'Drag the points for each argument to the appropriate boxes.',
        'diagram-description': {
            '1': 'Our success metrics determine what we can and cannot invest in',
            '2': 'We have allowed a minority to dictate those metrics',
            '3': 'We place a higher value investments based primarily on their return on net assets, internal rate of return, and earnings per share over other metrics',
            '4': 'As a result, investing to create growth and jobs is a third-best option, behind efficiency innovations (first) and doing nothing (second)'
        },
        'elements': {
            'one': 'The metrics we use to measure success lead us to invest more in finding efficiencies than in creating growth',
            'two': 'We place a higher value investments based primarily on their return on net assets, internal rate of return, and earnings per share over other metrics',
            'three': 'Leads us to invest in innovations that squeeze costs and noncash assets',
            'four': 'As a result, investing to create growth and jobs is a third-best option, behind efficiency innovations (first) and doing nothing (second)',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a3/diagram1/i18n/en.js